import { Component, OnInit, signal } from '@angular/core';
import { FooterService } from '../../services/footer/footer.service';
import { TranslateService } from '@ngx-translate/core';
import { PassingDataSurveyService } from '../../services/survey/passing-data-survey.service';
import { NgClass, NgIf } from '@angular/common';
import { Language } from './mini-footer';
import { languages} from './mini-footer.json';
@Component({
  selector: 'app-mini-footer',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './mini-footer.component.html',
  styleUrl: './mini-footer.component.scss'
})
export class MiniFooterComponent implements OnInit {
  langData = languages;
  thisYear = new Date().getFullYear();
  currentLang = signal<string>('');
  showLang: Language = {
    id: true,
    en: true
  };
  constructor(
    private passingDataFromSurvey: PassingDataSurveyService,
    private footerService: FooterService,
    public translateService: TranslateService
  ) { 
    this.translateService.use('id');
    this.currentLang.set(this.translateService.currentLang);
  }

  ngOnInit() {
    this.footerService.getLang().subscribe(footer => {
      this.showLang = footer;
    });
  }

  changeLang(lang: string) {
    this.passingDataFromSurvey.changeLang(lang);
    this.translateService.use(lang);
    this.currentLang.set(lang);
  }

}
